// country-rules.js — Tempolimits, Maut und Bußgeld-Richtwerte für Camper in 22 Ländern (Stand 2026-10-25).
// ERZEUGT aus der Recherche vom 2026-10-25 (je Land Quellen in `sources`, bevorzugt Ministerien, Mautbetreiber,
// ADAC/ÖAMTC; Widersprüche sind in den Rohdaten dokumentiert, die strengere bzw. amtliche Angabe gilt).
// Tempo je Klasse [innerorts, außerorts, Schnellstraße, Autobahn] in km/h; null = keine gesicherte Angabe,
// 'none' = keine allgemeine Grenze, 'signed' = nur nach Beschilderung. Texte kommen aus i18n `rules.*`, Aufbereitung in country-rules-view.js.
// Nichts schätzen: was nicht belegt ist, bleibt null und wird als „keine gesicherte Angabe“ gezeigt.

export const RULES_ASOF = '2026-10-25';
export const CLASSES = ['car', 'rv', 'trailer'];
export const ROADS = ['urban', 'rural', 'expressway', 'motorway'];
export const RULES = {
 "AT": {
  "speed": {
   "car": [
    50,
    100,
    100,
    130
   ],
   "rv": [
    50,
    70,
    80,
    80
   ],
   "trailer": [
    50,
    70,
    80,
    80
   ]
  },
  "speed_notes": [
   "trailer_strict"
  ],
  "toll": {
   "car": "vignette",
   "heavy": "distance",
   "url": "https://shop.asfinag.at"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 60,
    "from": 1
   },
   "phone": {
    "min": 100
   }
  },
  "hints": [
   "vest",
   "winter_cond",
   "wheel_chock"
  ],
  "sources": [
   "https://www.oeamtc.at/thema/vorschriften-strafen/zulaessige-hoechstgeschwindigkeiten-in-oesterreich-16182124",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/oesterreich/uebersicht/tempolimits/",
   "https://www.asfinag.at/maut-vignette/",
   "https://www.asfinag.at/media/xzqgtpxn/mautordnung_v38_de_komplett.pdf",
   "https://help.asfinag.at/en/go-toll/",
   "https://go-pilot.asfinag.at/unser-go-mautsystem/",
   "https://www.oeamtc.at/Strafenkatalog+%26+Promillegrenzen+in+Europa+2026.pdf/78.088.209",
   "https://www.oesterreich.gv.at/de/themen/mobilitaet/kfz/10/4/Seite.063220"
  ]
 },
 "BE": {
  "speed": {
   "car": [
    50,
    70,
    120,
    120
   ],
   "rv": [
    50,
    70,
    90,
    90
   ],
   "trailer": [
    50,
    70,
    90,
    90
   ]
  },
  "speed_notes": [
   "trailer_strict"
  ],
  "toll": {
   "car": "none",
   "heavy": "none",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 128
   },
   "phone": null
  },
  "hints": [
   "vest"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/belgien/fahrzeug/",
   "https://adac.de/reise-freizeit/reiseplanung/reiseziele/belgien/uebersicht/camper-gespanne",
   "https://newmobility.news/en/2025/10/06/belgiums-new-road-code-delayed-to-2027/",
   "https://www.adac.de/reise-freizeit/maut-vignette/belgien/",
   "https://www.politie.be/5343/nl/nieuws/verkeersveiligheid-nieuwe-bedragen-vanaf-1-juli-2026",
   "https://mobilit.belgium.be/nl/news/onmiddellijke-inningen-verhoging-van-de-bedragen-op-1-juli-2026",
   "https://www.vrt.be/vrtnws/nl/2026/06/04/verkeersboetes-gsm-achter-stuur/",
   "https://topgear.nl/autonieuws/telefoongebruik-achter-het-stuur-in-belgie/"
  ]
 },
 "CH": {
  "speed": {
   "car": [
    50,
    80,
    100,
    120
   ],
   "rv": [
    50,
    80,
    100,
    100
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [
   "trailer_permit"
  ],
  "toll": {
   "car": "vignette",
   "heavy": "flat",
   "url": "https://via.admin.ch/shop/dashboard"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "CHF",
   "speed20": {
    "min": 240
   },
   "phone": {
    "min": 100,
    "from": 1
   }
  },
  "hints": [
   "lights_day",
   "fire_ext_rv",
   "chains_sign"
  ],
  "sources": [
   "https://www.tcs.ch/de/camping-reisen/camping-insider/ratgeber/sicheres-reisen/tempo-100-auf-schweizer-autobahnen-fuer-wohnwagengespanne.php",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/schweiz/uebersicht/tempolimits/",
   "https://www.bazg.admin.ch/de/faq-vignette-und-e-vignette-erwerb",
   "https://www.bazg.admin.ch/de/pauschale-schwerverkehrsabgabe-psva-fuer-im-ausland-immatrikulierte-fahrzeuge",
   "https://bazg.admin.ch/dam/bazg/de/dokumente/abgaben/AVEA/AVAA/R%2015-01%20Nationalstrassenabgabe%20(Autobahnvignette)%20.pdf.download.pdf/R%2015-01%20Nationalstrassenabgabe%20(Autobahnvignette).pdf",
   "https://www.ch.ch/en/driving-over-speed-limit",
   "https://www.ch.ch/de/fahrzeuge-und-verkehr/verhalten-im-strassenverkehr/verkehrsregeln/alkohol-am-steuer/",
   "https://www.bfu.ch/de/services/rechtsfragen/alkoholgrenzwerte-schweizer-verkehr"
  ]
 },
 "CZ": {
  "speed": {
   "car": [
    50,
    90,
    110,
    130
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [],
  "toll": {
   "car": "vignette",
   "heavy": "distance",
   "url": "https://edalnice.gov.cz/"
  },
  "alcohol": 0.0,
  "fines": {
   "currency": "CZK",
   "speed20": {
    "min": 1500,
    "max": 2000
   },
   "phone": {
    "min": 2500,
    "max": 3500
   }
  },
  "hints": [
   "lights_day",
   "winter_cond",
   "radar_ban"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/tschechien/uebersicht/tempolimits/",
   "https://www.zakonyprolidi.cz/cs/2000-361",
   "https://edalnice.gov.cz/en/price-list",
   "https://edalnice.gov.cz/en/",
   "https://www.adac.de/reise-freizeit/maut-vignette/tschechien/"
  ]
 },
 "DE": {
  "speed": {
   "car": [
    50,
    100,
    "none",
    "none"
   ],
   "rv": [
    50,
    80,
    100,
    100
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [
   "de_nolimit",
   "trailer_permit",
   "rv_registration"
  ],
  "toll": {
   "car": "none",
   "heavy": "none",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 60
   },
   "phone": {
    "min": 100
   }
  },
  "hints": [
   "vest",
   "triangle",
   "winter_cond"
  ],
  "sources": [
   "https://www.gesetze-im-internet.de/stvo_2013/__3.html",
   "https://www.gesetze-im-internet.de/stvo_2013/__18.html",
   "https://www.gesetze-im-internet.de/stvoausnv_12/BJNR086600005.html",
   "https://anwaltverein.de/newsroom/verkr-14-26-tempo-80-fuer-schwere-wohnmobile-tempolimit-auf-autobahnen",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/deutschland/fahrzeug/",
   "https://www.tuev-nord.de/de/privatkunden/verkehr/auto-motorrad-caravan/gespanne-100kmh-zulassung/",
   "https://www.adac.de/news/wohnmobil-lkw-maut-ab-3-5-tonnen/",
   "https://www.toll-collect.de/de/toll_collect/rund_um_die_maut/mautbefreiung/mautbefreiung.html"
  ]
 },
 "DK": {
  "speed": {
   "car": [
    50,
    80,
    80,
    130
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [
   "trailer_permit"
  ],
  "toll": {
   "car": "bridges",
   "heavy": "bridges",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "DKK",
   "speed20": {
    "min": 1800
   },
   "phone": {
    "min": 1500
   }
  },
  "hints": [
   "lights_day",
   "low_emission"
  ],
  "sources": [
   "https://danskelove.dk/f%C3%A6rdselsloven/42",
   "https://danskelove.dk/f%C3%A6rdselsloven/43",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/daenemark/fahrzeug/",
   "https://www.oeamtc.at/laenderinfo/daenemark/",
   "https://www.adac.de/reise-freizeit/maut-vignette/daenemark/",
   "https://vejafgifter.dk/en/who-has-to-pay",
   "https://politi.dk/-/media/mediefiler/landsdaekkende-dokumenter/service-og-tilladelser/boeder/bed-om-et-retsmoede/vejledende-boedetakster-ved-overtraedelse-af-faerdselsloven.pdf",
   "https://www.borger.dk/politi-retsvaesen-forsvar/Politi/Faerdselsloven-og-fartgraenser"
  ]
 },
 "ES": {
  "speed": {
   "car": [
    30,
    90,
    null,
    120
   ],
   "rv": [
    30,
    80,
    null,
    90
   ],
   "trailer": [
    30,
    80,
    null,
    90
   ]
  },
  "speed_notes": [
   "es_urban"
  ],
  "toll": {
   "car": "distance",
   "heavy": "distance",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 100
   },
   "phone": {
    "min": 200
   }
  },
  "hints": [
   "warning_board",
   "triangle",
   "vest"
  ],
  "sources": [
   "https://www.dgt.es/export/sites/web-DGT/.galleries/downloads/muevete-con-seguridad/normas-de-trafico/NOR-normativa-general/report_Instruccion-PROT-2026_04-Autocaravanas.pdf",
   "https://www.dgt.es/muevete-con-seguridad/viaja-seguro/en-autocaravana/",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/spanien/uebersicht/tempolimits/",
   "https://www.adac.de/reise-freizeit/maut-vignette/spanien/",
   "https://www.bidegi.eus/es/gure-autobideak#a-636",
   "https://www.dgt.es/nuestros-servicios/multas-y-sanciones/conoce-los-tipos-de-infracciones-y-sanciones/"
  ]
 },
 "FI": {
  "speed": {
   "car": [
    50,
    80,
    "signed",
    "signed"
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [
   "signed",
   "trailer_strict",
   "rv_registration"
  ],
  "toll": {
   "car": "none",
   "heavy": "none",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 170
   },
   "phone": {
    "min": 100
   }
  },
  "hints": [
   "lights_day",
   "winter_cond"
  ],
  "sources": [
   "https://www.finlex.fi/fi/lainsaadanto/2018/729",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/finnland/fahrzeug/",
   "https://www.oeamtc.at/laenderinfo/finnland/",
   "https://www.mtvuutiset.fi/artikkeli/perakarrynkin-kanssa-saa-painaa-satasta-ajoneuvokohtaiset-nopeusrajoitukset-muuttuvat-maanantaina/7829212"
  ]
 },
 "FR": {
  "speed": {
   "car": [
    50,
    80,
    110,
    130
   ],
   "rv": [
    50,
    80,
    100,
    110
   ],
   "trailer": [
    50,
    80,
    110,
    130
   ]
  },
  "speed_notes": [
   "fr_rural",
   "rain",
   "trailer_light"
  ],
  "toll": {
   "car": "distance",
   "heavy": "distance",
   "url": "https://www.autoroutes.fr/"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 135
   },
   "phone": {
    "min": 135
   }
  },
  "hints": [
   "vest",
   "blind_spot",
   "crit_air"
  ],
  "sources": [
   "https://www.service-public.gouv.fr/particuliers/vosdroits/F19460?lang=en",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/frankreich/uebersicht/tempolimits/",
   "https://www.oeamtc.at/laenderinfo/frankreich/frankreich-welche-verkehrsregeln-sollte-man-unbedingt-kennen-81096949/print",
   "https://www.adac.de/reise-freizeit/maut-vignette/frankreich/",
   "https://www.service-public.gouv.fr/particuliers/vosdroits/F31551?lang=en",
   "https://www.interieur.gouv.fr/actualites/communiques-de-presse/tres-grand-exces-de-vitesse-devient-delit-a-partir-du-29-decembre-2025",
   "https://www.certificat-air.gouv.fr/",
   "https://lcp.fr/actualites/zfe-le-conseil-constitutionnel-censure-la-suppression-des-zones-a-faibles-emissions"
  ]
 },
 "GB": {
  "speed": {
   "car": [
    48,
    96,
    112,
    112
   ],
   "rv": [
    48,
    80,
    96,
    112
   ],
   "trailer": [
    48,
    80,
    96,
    96
   ]
  },
  "speed_notes": [
   "gb_mph",
   "gb_weight"
  ],
  "toll": {
   "car": "mixed",
   "heavy": "mixed",
   "url": "https://www.gov.uk/pay-dartford-crossing-charge"
  },
  "alcohol": 0.8,
  "fines": {
   "currency": "GBP",
   "speed20": {
    "min": 100,
    "from": 1
   },
   "phone": {
    "min": 200
   }
  },
  "hints": [
   "ulez",
   "low_emission"
  ],
  "sources": [
   "https://www.gov.uk/speed-limits",
   "https://www.gov.uk/pay-dartford-crossing-charge",
   "https://www.gov.uk/pay-dartford-crossing-charge/charges",
   "https://www.gov.uk/government/publications/heavy-good-vehicle-levy-new-reformed-levy/heavy-goods-vehicle-hgv-levy-introduction-of-new-reformed-levy",
   "https://tfl.gov.uk/modes/driving/ultra-low-emission-zone",
   "https://www.gov.uk/clean-air-zones",
   "https://www.gov.uk/speeding-penalties",
   "https://www.gov.uk/using-mobile-phones-when-driving-the-law"
  ]
 },
 "GR": {
  "speed": {
   "car": [
    null,
    90,
    110,
    130
   ],
   "rv": [
    null,
    80,
    null,
    80
   ],
   "trailer": [
    null,
    80,
    80,
    90
   ]
  },
  "speed_notes": [
   "gr_urban",
   "trailer_strict"
  ],
  "toll": {
   "car": "distance",
   "heavy": "distance",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 150
   },
   "phone": {
    "min": 350
   }
  },
  "hints": [
   "triangle",
   "radar_ban"
  ],
  "sources": [
   "https://europa.eu/youreurope/citizens/travel/driving-abroad/road-rules-and-safety/greece/index_en.htm",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/griechenland/uebersicht/tempolimits/",
   "https://www.gocar.gr/news/feed/50544%2Cmegales_allages_neoy_KOK_poines_kai_ta_p.html",
   "https://www.adac.de/reise-freizeit/maut-vignette/griechenland/",
   "https://www.skai.gr/news/greece/odigisi-se-isxy-o-neos-kok-apo-simera-ta-prostima-kai-oi-poines-1"
  ]
 },
 "HR": {
  "speed": {
   "car": [
    50,
    90,
    110,
    130
   ],
   "rv": [
    50,
    80,
    80,
    90
   ],
   "trailer": [
    50,
    80,
    80,
    90
   ]
  },
  "speed_notes": [],
  "toll": {
   "car": "distance",
   "heavy": "distance",
   "url": "https://www.hac.hr/en/toll/etc"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 60
   },
   "phone": {
    "min": 130
   }
  },
  "hints": [
   "lights_winter",
   "winter_cond",
   "vest"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/kroatien/uebersicht/tempolimits/",
   "https://www.oeamtc.at/laenderinfo/kroatien/kroatien-welche-verkehrsregeln-sollte-man-unbedingt-kennen-77650904",
   "https://www.hac.hr/en/toll/toll-rates",
   "https://www.hac.hr/en/about-us/eu-projects/the-recovery-and-resilience-facility/electronic-toll-collection-system",
   "https://teleskop.hr/hrvatska/nijemci-najavili-hac-ih-ispravio-evo-kad-krece-novi-sustav-naplate-cestareine-nije-tako-daleko/",
   "https://prometni-propisi.hr/2025/07/24/kazne-za-prekoracenje-brzine-kretanja/",
   "https://www.zakon.hr/z/78/zakon-o-sigurnosti-prometa-na-cestama"
  ]
 },
 "HU": {
  "speed": {
   "car": [
    50,
    90,
    110,
    130
   ],
   "rv": [
    50,
    70,
    70,
    80
   ],
   "trailer": [
    50,
    70,
    70,
    80
   ]
  },
  "speed_notes": [],
  "toll": {
   "car": "vignette",
   "heavy": "vignette",
   "url": "https://nemzetiutdij.hu/"
  },
  "alcohol": 0.0,
  "fines": {
   "currency": "HUF",
   "speed20": {
    "min": 50000
   },
   "phone": null
  },
  "hints": [
   "lights_rural",
   "vest"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/ungarn/uebersicht/tempolimits/",
   "https://www.adac.de/reise-freizeit/maut-vignette/ungarn/",
   "https://e-autopalyamatrica.hu/en/lakoauto-matrica-2026",
   "https://lexiq.hu/traffipax/buntetes",
   "https://szamoldki.hu/hu/hirek/traffipax-kalkulator-2026-ennyi-most-a-gyorshajtas-birsaga"
  ]
 },
 "IT": {
  "speed": {
   "car": [
    50,
    90,
    110,
    130
   ],
   "rv": [
    50,
    80,
    80,
    100
   ],
   "trailer": [
    50,
    70,
    70,
    80
   ]
  },
  "speed_notes": [
   "disputed",
   "rain"
  ],
  "toll": {
   "car": "distance",
   "heavy": "distance",
   "url": "https://www.autostrade.it/"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 173,
    "max": 694
   },
   "phone": {
    "min": 250,
    "max": 1000
   }
  },
  "hints": [
   "warning_board",
   "vest",
   "lights_rural"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/italien/uebersicht/tempolimits/",
   "https://www.aci.it/fileadmin/cds/art-142.php",
   "https://europa.eu/youreurope/citizens/travel/driving-abroad/road-rules-and-safety/italy/index_en.htm",
   "https://www.adac.de/reise-freizeit/maut-vignette/italien/",
   "https://rivistagiuridica.aci.it/fileadmin/Documenti/2025/Dottrina_e_Approfondimenti/Codice_della_strada_novita_del_quadro_sanzionatorio_1_agosto_2025.pdf",
   "https://www.adac.de/verkehr/recht/bussgeld-punkte/ausland/"
  ]
 },
 "LU": {
  "speed": {
   "car": [
    50,
    90,
    null,
    130
   ],
   "rv": [
    50,
    null,
    null,
    null
   ],
   "trailer": [
    50,
    75,
    null,
    90
   ]
  },
  "speed_notes": [
   "disputed",
   "rain"
  ],
  "toll": {
   "car": "none",
   "heavy": "none",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 49
   },
   "phone": {
    "min": 250
   }
  },
  "hints": [
   "vest",
   "winter_cond"
  ],
  "sources": [
   "https://www.visitluxembourg.com/de/planen-sie-ihren-aufenthalt/mobilitaet-vor-ort/verkehrsvorschriften",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/luxemburg/fahrzeug/",
   "https://www.touring.be/fr/articles/regles-de-circulation-au-luxembourg",
   "https://www.stol.it/artikel/wirtschaft/strassenmaut-kann-beim-urlaub-in-europa-teuer-werden",
   "https://transports.public.lu/fr/conduire/circulation-et-securite-routieres/radars.html",
   "https://guichet.public.lu/fr/citoyens/transport/transports-individuels/infractions/payer-contester-avertissement-taxe.html",
   "https://transports.public.lu/fr/plus/faq/handy-um-steier.html",
   "https://police.public.lu/en/actualites/2024/05/semaine-21/bilan-campagne-distraction.html"
  ]
 },
 "NL": {
  "speed": {
   "car": [
    50,
    80,
    100,
    100
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    80,
    90,
    90
   ]
  },
  "speed_notes": [
   "nl_day",
   "trailer_light"
  ],
  "toll": {
   "car": "none",
   "heavy": "none",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 243
   },
   "phone": {
    "min": 440
   }
  },
  "hints": [
   "chains_ban",
   "radar_ban"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/niederlande/uebersicht/tempolimits/",
   "https://www.rijksoverheid.nl/onderwerpen/verkeersveiligheid/vraag-en-antwoord/wat-is-de-maximumsnelheid-voor-auto-s-op-de-snelweg",
   "https://www.anwb.nl/auto/rijbewijs/tips-aanhanger/rijden-met-aanhanger-tips",
   "https://www.anwb.nl/vakantie/nederland/reisvoorbereiding/verkeersregels",
   "https://www.adac.de/reise-freizeit/maut-vignette/niederlande/",
   "https://www.rdw.nl/over-rdw/actueel/dossiers/tolheffing",
   "https://www.vrachtwagenheffing.nl/vrijstelling",
   "https://www.rijksoverheid.nl/actueel/nieuws/2025/12/17/kabinet-zet-met-belastingwijzigingen-2026-stappen-naar-een-beter-belastingstelsel"
  ]
 },
 "NO": {
  "speed": {
   "car": [
    50,
    80,
    "signed",
    "signed"
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    80,
    80,
    80
   ]
  },
  "speed_notes": [
   "signed",
   "trailer_permit",
   "rv_registration"
  ],
  "toll": {
   "car": "mixed",
   "heavy": "mixed",
   "url": "https://www.epass24.com"
  },
  "alcohol": 0.2,
  "fines": {
   "currency": "NOK",
   "speed20": {
    "min": 7450
   },
   "phone": {
    "min": 10750
   }
  },
  "hints": [
   "lights_day",
   "winter_heavy",
   "low_emission"
  ],
  "sources": [
   "https://lovdata.no/dokument/SF/forskrift/1986-03-21-747/KAPITTEL_4",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/norwegen/fahrzeug/",
   "https://www.adac.de/reise-freizeit/maut-vignette/norwegen/",
   "https://lovdata.no/dokument/SF/forskrift/1990-06-29-492",
   "https://lovdata.no/dokument/NL/lov/1965-06-18-4"
  ]
 },
 "PL": {
  "speed": {
   "car": [
    50,
    90,
    100,
    140
   ],
   "rv": [
    50,
    70,
    80,
    80
   ],
   "trailer": [
    50,
    70,
    80,
    80
   ]
  },
  "speed_notes": [
   "pl_expressway"
  ],
  "toll": {
   "car": "mixed",
   "heavy": "distance",
   "url": "https://etoll.gov.pl/de"
  },
  "alcohol": 0.2,
  "fines": {
   "currency": "PLN",
   "speed20": {
    "min": 200
   },
   "phone": {
    "min": 500
   }
  },
  "hints": [
   "lights_day",
   "low_emission",
   "radar_ban"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/polen/fahrzeug/",
   "https://www.adac.de/reise-freizeit/maut-vignette/polen/",
   "https://api.sejm.gov.pl/eli/acts/DU/2021/2484/text.pdf",
   "https://api.sejm.gov.pl/eli/acts/DU/2023/1256/text.pdf"
  ]
 },
 "PT": {
  "speed": {
   "car": [
    50,
    90,
    100,
    120
   ],
   "rv": [
    50,
    80,
    90,
    100
   ],
   "trailer": [
    50,
    70,
    80,
    100
   ]
  },
  "speed_notes": [
   "rv_registration"
  ],
  "toll": {
   "car": "mixed",
   "heavy": "mixed",
   "url": null
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 60,
    "max": 300
   },
   "phone": {
    "min": 250,
    "max": 1250
   }
  },
  "hints": [
   "warning_board",
   "triangle",
   "vest"
  ],
  "sources": [
   "https://ansr.pt/sites/default/files/2026-07/republicacao-do-codigo-da-estrada.pdf",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/portugal/uebersicht/tempolimits/",
   "https://europa.eu/youreurope/citizens/travel/driving-abroad/road-rules-and-safety/portugal/index_en.htm",
   "https://www.adac.de/reise-freizeit/maut-vignette/portugal/"
  ]
 },
 "SE": {
  "speed": {
   "car": [
    50,
    70,
    "signed",
    "signed"
   ],
   "rv": [
    50,
    70,
    "signed",
    "signed"
   ],
   "trailer": [
    50,
    70,
    80,
    80
   ]
  },
  "speed_notes": [
   "signed",
   "rv_registration"
  ],
  "toll": {
   "car": "mixed",
   "heavy": "mixed",
   "url": null
  },
  "alcohol": 0.2,
  "fines": {
   "currency": "SEK",
   "speed20": {
    "min": 2400
   },
   "phone": {
    "min": 1500
   }
  },
  "hints": [
   "lights_day",
   "winter_cond",
   "low_emission"
  ],
  "sources": [
   "https://transportstyrelsen.se/globalassets/global/vag/trafikregler/hastighetstabla2.pdf",
   "https://www.transportstyrelsen.se/sv/vagtrafik/trafikregler-och-vagmarken/trafikregler/beslut-i-overklagningsarenden/hastigheter/hastighet-inom-tattbebyggt-omrade-i-kils-kommun/",
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/schweden/fahrzeug/",
   "https://regeringen.se/pressmeddelanden/2026/07/regeringen-remitterar-forslag-som-ska-mojliggora-effektivare-vagtransporter/",
   "https://www.adac.de/reise-freizeit/maut-vignette/schweden/",
   "https://www.transportstyrelsen.se/sv/vagtrafik/fordon/skatter-och-avgifter/vagavgift-for-tunga-fordon/",
   "https://www.svenskforfattningssamling.se/sites/default/files/sfs/2021-02/SFS2021-119.pdf",
   "https://minbilkoll.se/trafikregler/mobil-vid-ratten/"
  ]
 },
 "SI": {
  "speed": {
   "car": [
    50,
    90,
    110,
    130
   ],
   "rv": [
    50,
    80,
    80,
    80
   ],
   "trailer": [
    50,
    90,
    100,
    100
   ]
  },
  "speed_notes": [
   "trailer_light"
  ],
  "toll": {
   "car": "vignette",
   "heavy": "distance",
   "url": "https://evinjeta.dars.si/"
  },
  "alcohol": 0.5,
  "fines": {
   "currency": "EUR",
   "speed20": {
    "min": 60
   },
   "phone": {
    "min": 250
   }
  },
  "hints": [
   "lights_day",
   "winter_cond",
   "vest"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/slowenien/uebersicht/tempolimits/",
   "https://www.amzs.si/na-poti/prikaz-prometnih-podatkov-po-evropskih-drzavah/slovenija",
   "https://evinjeta.dars.si/hr/o-e-vinjeti",
   "https://www.adac.de/reise-freizeit/maut-vignette/slowenien/"
  ]
 },
 "SK": {
  "speed": {
   "car": [
    50,
    90,
    null,
    130
   ],
   "rv": [
    50,
    90,
    null,
    90
   ],
   "trailer": [
    50,
    90,
    null,
    90
   ]
  },
  "speed_notes": [],
  "toll": {
   "car": "vignette",
   "heavy": "mixed",
   "url": "https://eznamka.sk/"
  },
  "alcohol": 0.0,
  "fines": {
   "currency": "EUR",
   "speed20": null,
   "phone": null
  },
  "hints": [
   "lights_day",
   "winter_cond",
   "triangle"
  ],
  "sources": [
   "https://www.adac.de/reise-freizeit/reiseplanung/reiseziele/slowakei/fahrzeug/",
   "https://www.oeamtc.at/laenderinfo/slowakei/slowakei-welche-verkehrsregeln-sollte-man-unbedingt-kennen-81389499",
   "https://eznamka.sk/en/evignettes/types-and-prices",
   "https://eznamka.sk/en/charged-vehicles",
   "https://www.adac.de/reise-freizeit/maut-vignette/slowakei/",
   "https://carmate.sk/blog/pokuty-za-rychlost-od-1-9-2026"
  ]
 }
};

